export * from './use-swr';
import { default as useSWR } from './use-swr';
export { useSWRPages } from './use-swr-pages';
export { cache } from './config';
export default useSWR;
